import { ReactElement, useState, ChangeEvent } from "react";
import { className } from "../../../shared/helpers";
import styles from "./CustomCheckbox.module.scss";

interface CustomCheckboxProps
{
    label: string;
    customClassName?: string;
    handleChange: (x: boolean) => void;
    disabled?: boolean;
}

const CustomCheckbox = (props: CustomCheckboxProps): ReactElement =>
{
    const [checked, setChecked] = useState<boolean>(false);

    const handleInputChange = (e: ChangeEvent): void =>
    {
        if (props.disabled) return;
        
        const target = e.target as HTMLInputElement;
        props.handleChange(target.checked);
        setChecked(target.checked);
    }

    return (
        <button
            {...className(
                styles.customCheckbox,
                props.customClassName, {
                [styles.checked]: checked
            })}
            disabled={props.disabled}
        >
            <input type="checkbox" onChange={handleInputChange} disabled={props.disabled}/>
            <i className="material-icons">{checked ? "check_box" : "check_box_outline_blank"}</i>
            <span>{props.label}</span>
        </button>
    );
};

export default CustomCheckbox;
